export const NO_ASSIGNEE_OPTION = {
  value: 'no_assignee',
  label: 'No assignee',
} as const;
